import { render, staticRenderFns } from "./CiBreadcrumbs.vue?vue&type=template&id=588e2d82&"
import script from "./CiBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./CiBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./CiBreadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports